// extracted by mini-css-extract-plugin
export default {"input":"mda-z","button":"nda-z","selected":"oda-z","unavailable":"pda-z","oos":"qda-z","paperCutDisabledOverlay":"rda-z","image":"sda-z"};